export default __webpack_public_path__ + "static/media/Horby_full.390e902e.png";